import {useEffect, useState} from "react";

// Whether a CSS media query (e.g. "(min-width: 768px)") currently matches; updates on change
export const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(() =>
        typeof window !== "undefined" && window.matchMedia(query).matches);

    useEffect(() => {
        const mediaQuery = window.matchMedia(query);
        const update = () => setMatches(mediaQuery.matches);
        update();
        mediaQuery.addEventListener("change", update);
        return () => mediaQuery.removeEventListener("change", update);
    }, [query]);

    return matches;
};
